// extracted by mini-css-extract-plugin
module.exports = {"nav":"GuideNav_nav__KczFK"};